define('gumbo-js-client-lib/forms/liveData/LineupsForm',{
	batters: null,
	battingOrder: null,
	pitchers: null,
	bench: null,
	bullpen: null
});
